import { UserInterface } from 'Interfaces'
import { Avatar } from 'antd'
import styles from './styles.module.scss'

const UserCell = (name: string, record: any) => {
  const { firstname, lastname } = record

  if (!record.id) return <div className={styles.userCell} />

  return (
    <div className={styles.userCell}>
      {!firstname && !lastname ? (
        <p>N/A</p>
      ) : (
        <p>
          {firstname} {lastname}
        </p>
      )}
    </div>
  )
}

export default UserCell
